import {
  ApiResponse,
  AssessmentRequest,
  AssessmentResponse,
} from '../types/api';
import { lifeApi } from './base';

const postAssessment = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    postAssessment: builder.mutation<
      ApiResponse<AssessmentResponse>,
      AssessmentRequest
    >({
      query: (body) => ({
        url: '/',
        method: 'POST',
        body,
        params: {
          relativeUrl: 'applications/uw/assessments',
        },
      }),
    }),
  }),
});

export const { usePostAssessmentMutation } = postAssessment;
